import { ApiUrl } from "../../../api/apiConfig";
import axios from "axios";

export const submitAnswers = (data) => {
	return axios.post(`${ApiUrl}/submit-answers`, data);
};

export const submitReferral = (data) => {
	return axios.post(`${ApiUrl}/submit-referral`, data);
};
